<template>
  <div class="GoodsCombination" ref="GoodsCombination">
    <div class="group-list">
      <div class="header">
        <span class="header-tit">万人拼团价更低</span>
        <div class="header-bottom">
          <div class="head-sculpture">
            <div 
              class="head-sculpture-img"
              v-for="(item,index) in combinationInfo.lst" 
              :key="index" 
              >
              <img :src="item.avatar" mode="widthFix" />
            </div>
          </div>
          <span class="font-color-fff user-number">
            {{combinationInfo.count === 0?`快去发起拼团吧 ~`:`超过${combinationInfo.count}人参与了团购`}}
          </span>
        </div>
        <div class="group-header-tit">
          <span class="">///</span>
          <span class="">正在疯抢</span>
          <span class="">///</span>
        </div>
      </div>
      <div class="list">
        <div
          class="item acea-row row-between-wrapper"
          @click="openSubcribe(item)"
          data-item=""
          data-url="/pages/activity/goods_combination_details/index?id="
          v-for="(item,index) in combinationList"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" lazy-load="true" mode="aspectFit" />
            <div 
              class="coverimg"
              v-if="!item.com.status && !item.com.stock"
              >抢光了</div>
          </div>
          <div class="text cover">
            <div class="line1">{{item.title}}</div>
            <div class="store-percent">
              <div class="store-percent-child">
                <div class="cu-progress acea-row row-middle round margin-top">
                  <div
                    class="acea-row row-middle bg-red"
                    :style="{width:item.progress + '%'}"
                  ></div>
                </div>
                <span class="store-percent-num">已抢{{item.sales}}件</span>
              </div>
              <span class="progress-cancel font-color">{{item.progress || 0}}%</span>
            </div>

            <div class="store-percent store-percent-cba" v-if="item.want_num">
              <img v-for="(items,index) in item.want_user" :key="index" :src="items" lazy-load="true" mode="aspectFit" />

              <span class="progress-cancel font-color-ff6e66 cbanumber"
                >等人{{item.want_num}}想买</span
              >
            </div>
            <div class="acea-row">
              <div class="team acea-row row-middle cart-color">
                <div class="iconfont icon-pintuan"></div>
                <div class="num">{{item.people}}人团</div>
              </div>
            </div>
            <div class="bottom acea-row row-between-wrapper">
              <div class="money font-color">
                ￥<span class="num">{{item.price}}</span
                ><span class="y1-money">已降{{item.price_cut}}元</span
                ><span class="y-money">{{item.product_price}}</span>
              </div>
              <button 
                class="groupBnt bg-color"
                v-if="item.com.status && item.com.stock"
                >
                去拼团<span class="iconfont icon-jiantou"></span>
              </button>
              <button 
                class="groupBnt bg-color-hui"
                v-else-if="item.com.status && !item.com.stock"
                >
                抢光了<span class="iconfont icon-jiantou"></span>
              </button>
              <button 
                class="groupBnt" 
                catchtap="remindBtn"
                v-else-if="!item.com.status"
                >
                <span class="iconfont icon-jiantou"></span>
              </button>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <!-- 底部加载 -->
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import {getCombinationNumber} from "@api/activity"
import {getCombinationList} from "@api/activity"
import Loading from "@components/Loading";
export default {
  name: "GoodsCombination",
  components:{
    Loading
  },
  data(){
    return{
      combinationInfo:{},
      combinationList:[],
      limit:4,
      page:1,
      loading:false,
      loadend:false,
      loadTitle: "",
    }
  },
  methods:{
    getCombinationUserNumber(){
      getCombinationNumber().then(res => {
        this.combinationInfo = res.data;
      })
    },
    getCombinationList(){
      // 拼团商品列表
      let that = this;
      if(that.loadend) return that.$dialog.message("已全部加载");//加载完成操作;
      if(that.loading) return  that.$dialog.message("加载中")//加载中操作;
      var data = {
        page : this.page,
        limit : this.limit
      };
      this.loading = true;
      getCombinationList(data).then(res => {
        if(res.data.length == 0 && that.page == 1) that.$dialog.message("目前暂无拼团活动");
        res.data.forEach(item => {
          item.progress = parseInt(item.sales/item.quota_show*100);
          item.price_cut = (item.product_price-item.price).toFixed(2)
        })
        that.loadend = that.limit > res.data.length;
        that.combinationList = that.combinationList.concat(res.data);
        that.page++;
        that.loading = false;
      }).catch(()=>{
        that.loading = false;
      })
    },
    openSubcribe(item){
      if(item.com.status && !item.com.stock) return;
      this.$router.push({
        path: `/activity/goods_combination_details?id=${item.id}`
      })
    }
  },
  mounted(){
    this.getCombinationUserNumber();
    this.getCombinationList();
    this.$scroll(this.$refs.GoodsCombination,() => {
      !this.loading && this.getCombinationList();
    })
    
  }
};
</script>
<style scoped>
.group-list .list{
  margin-top: -0.3rem;
}
.store-percent-child .cu-progress{
  overflow: hidden;
  height: 0.2rem;
  background-color: #eee;
  width: 100%;
  border-radius: 10px;
}
.store-percent-child .cu-progress .bg-red{
  width: 0;
  height: 100%;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffa82c),
    to(#ff554c)
  );
  background-image: linear-gradient(to right, #ffa82c 0%, #ff554c 100%);
  position: relative;
}
.acea-row {
  display: flex;
  flex-wrap: wrap;
}
.acea-row.row-between-wrapper {
  align-items: center;
  justify-content: space-between;
}
.bg-color {
  background-color: #000 !important;
}
.font-color {
  color: #80cdd4!important;
}
.group-list .header {
  background-image: unset;
  height: 4rem;
}
.font-color-fff {
  color: #fff !important;
}
.GoodsCombination {
  background-color: #e6b978 !important;
  min-height: 100vh;
}
.group-list .list .item {
  width: 6.9rem;
  height: auto;
  background-color: #fff;
  border-radius: 3px;
  padding: 0 0.24rem 0.26rem;
  box-sizing: border-box;
  margin: 0 auto 0.2rem auto;
}
.group-list .list .item .pictrue {
  width: 100%;
  height: 3.6rem;
  position: relative;
  text-align: center;
  margin-bottom: 0.1rem;
}
.group-list .list .item .pictrue img {
  width: auto;
  height: 100%;
  border-radius: 3px;
}
.group-list .list .item .coverimg {
  width: calc(100% + 0.48rem);
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  top: 0;
  left: -0.24rem;
  z-index: 1000;
  font-size: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.group-list .list .item .text {
  width: 100%;
  font-size: 0.3rem;
  color: #232323;
  font-weight: 600;
}
.group-list .list .item .text .team {
  height: 0.38rem;
  border-radius: 2px;
  font-size: 0.22rem;
  margin-top: 0.2rem;
  color: #ff6e66 !important;
  border: 1px solid #ff6e66 !important;
}
.group-list .list .item .text .team .iconfont {
  width: 0.54rem;
  background-color: #ffdcd9;
  text-align: center;
  color: #dd3823;
  height: 100%;
}
.group-list .list .item .text .team .num {
  text-align: center;
  padding: 0 0.06rem;
  height: 100%;
}
.group-list .list .item .text .bottom {
  margin-top: 0.07rem;
}
.group-list .list .item .text .bottom .money {
  font-size: 0.24rem;
  font-weight: 700;
  color: #282828;
}
.group-list .list .item .text .bottom .money .num {
  font-size: 0.32rem;
}
.group-list .list .item .text .bottom .money .y-money {
  font-size: 0.24rem;
  color: #999;
  font-weight: 400;
  text-decoration: line-through;
  margin-left: 0.1rem;
}
.group-list .list .item .text .bottom .money .y1-money {
  font-size: 0.24rem;
  background: rgba(255, 85, 76, 0.14);
  margin: 0 0.2rem;
  padding: 0 0.1rem;
}
.group-list .list .item .text .bottom .groupBnt {
  font-size: 0.26rem;
  color: #fff;
  width: 1.46rem;
  height: 0.54rem;
  text-align: center;
  line-height: 0.54rem;
  border-radius: 14px;
}
.group-list .list .item .text .bottom .groupBnt .iconfont {
  font-size: 0.25rem;
  vertical-align: 0.02rem;
  margin-left: 0.1rem;
}
.header {
  padding: 0 0.3rem;
}
.header .header-tit,
.header .user-number {
  display: block;
  text-align: center;
  font-weight: 600;
  line-height: 3em;
  color: #fff;
}
.header .user-number {
  font-weight: 500;
  font-size: 0.9em;
  line-height: 1.2em;
}
.header-bottom {
  margin: 0 auto;
  width: 100%;
  padding: 1em;
  border-radius: 5px;
  background: #9dccd0;
}
.head-sculpture {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 69%;
  margin: 0 auto 0.1rem;
  overflow: hidden;
}
.head-sculpture img,
.store-percent img {
  width: 0.6rem;
  height: 0.6rem;
  margin: 0.12rem;
  border-radius: 50%;
}
.group-header-tit {
  display: flex;
  justify-content: center;
  color: #fff;
}
.group-header-tit span {
  display: inline-block;
  padding: 1em 0.1rem;
}
.store-percent {
  padding-top: 0.3rem;
  width: 60%;
  display: flex;
  align-items: center;
}
.store-percent-child {
  width: calc(100% - 1rem);
  position: relative;
}
.store-percent-child .store-percent-num {
  position: absolute;
  top: 50%;
  left: 0.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
  transform: translate(0, -50%);
  font-size: 0.16rem;
  color: #fff;
}
.store-percent span {
  display: block;
  width: 1rem;
  text-align: center;
}
.progress .wx-progress-inner-bar {
  border-radius: 4px !important;
  background: linear-gradient(to right, #ff6d40, #ff554c) !important;
}
.store-percent.store-percent-cba {
  width: 100%;
  word-wrap: break-word;
  padding-bottom: 0.1rem;
  align-items: center;
}
.store-percent.store-percent-cba img {
  width: 0.4rem;
  height: 0.4rem;
  margin: 0 0.04rem;
}
.store-percent .cbanumber {
  font-weight: 300;
  font-size: 0.8em;
  width: 2.4rem;
  text-align: left;
}
</style>